import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";

import { messages } from "@app/messages";
import { GlobalState } from "@app/models/state";
import { setTitleOnPage } from "@app/util";
import { canCreateAlbum as canCreateAlbumSelector } from "@music/selectors";
import { Iframe } from "@oldwata/components/Iframe";
import { Page, PageTitle } from "@ui/Page";

interface AlbumsCreateStateProps {
    canCreateAlbum: boolean;
}

const breadcrumbItems = [
    { text: <FormattedMessage {...messages.pageAlbumsCreateTitle} /> },
];

const AlbumsCreate = ({ canCreateAlbum }: AlbumsCreateStateProps) => (
    <Page style="blank" className="albums-create-page" breadcrumbs={breadcrumbItems}>
        <PageTitle tag="h1" className="display-2">
            <FormattedMessage {...messages.pageAlbumsCreateTitle} />
        </PageTitle>
        {canCreateAlbum &&
            <Iframe path="/album/new" />
        }
    </Page>
);

// Map the users state to the component.
const mapStateToProps = (state: GlobalState) => {
    return {
        canCreateAlbum: canCreateAlbumSelector(state),
    } as AlbumsCreateStateProps;
};

const ConnectedAlbumsCreate = compose<AlbumsCreateStateProps, {}>(
    setTitleOnPage(
        messages.pageAlbumsCreateTitle,
    ),
    connect(mapStateToProps, null),
)(AlbumsCreate);

export {
    AlbumsCreate as AlbumsCreatePresenter,
    ConnectedAlbumsCreate as AlbumsCreate,
};
